import { createFileRoute } from '@tanstack/react-router'
import { ProfilePending } from '../../../app/route-states'
import { teamQueryOptions } from '../../../features/tasks/queries'
import { TeamWorkspacePage } from '../../../features/teams/team-workspace-page'

export const Route = createFileRoute('/_app/teams/$teamId')({
  staticData: { crumb: 'team' },
  loader: ({ context, params }) => context.queryClient.ensureQueryData(teamQueryOptions(params.teamId)),
  pendingComponent: ProfilePending,
  component: TeamWorkspacePage,
})
